<script setup lang="ts">
import { storeToRefs } from 'pinia'
import BaseModal from '../wrappers/BaseModal.vue'
import { useModelWrapper } from '../wrappers/helpers/useModelWrapper'
import { useI18n } from 'vue-i18n'
import { useTimers } from '../../store/timers'
import { useRouter } from 'vue-router'
const props = defineProps<{
  modelValue: boolean
}>()
const emit = defineEmits<{
  (e: 'update:modelValue'): void
}>()
const value = useModelWrapper(props, emit)
const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`${key}`)

const router = useRouter()
const { getActiveChildTimer } = storeToRefs(useTimers())
const navigateToActiveTask = async () => {
  if (getActiveChildTimer.value) {
    await router.push(`/tasks/${getActiveChildTimer.value.data.task_id}`)
  }
}
</script>
<template>
  <BaseModal v-model="value">
    <template #title>
      <template v-if="getActiveChildTimer">
        {{ label('form.endStore') }}
      </template>
      <template v-else>
        {{ label('activities.store') }}
      </template>
    </template>
    <template #content>
      <template v-if="getActiveChildTimer"> {{ label('form.endStoreActiveTask') }}</template>
      <template v-else>
        {{ label('form.endCurrentMessage') }}
      </template>
    </template>
    <template #actions>
      <q-btn flat no-caps class="text-grey-7" :label="label('cancel')" v-close-popup />
      <q-btn
        @click="navigateToActiveTask"
        v-if="getActiveChildTimer"
        color="primary"
        :label="`${label('taskProfile.task')}: ${getActiveChildTimer?.data.task_id}`"
      />
    </template>
  </BaseModal>
</template>
